import zIndex from '@material-ui/core/styles/zIndex'

const styles = theme => ({
  standAloneDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  drawer: {
    width: '280px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  drawerOpen: {
    width: '280px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: 'fixed',
    height: 'calc(100%)',

    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    /*  overflowY: 'hidden',
    overflowX: 'hidden',
    '&:hover': {
      overflowY: 'auto',
      overflowX: 'hidden',
    }, */
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7),
    position: 'fixed',

    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    height: 'calc(100%)',
  },
  drawerOpenPaper: {
    width: '280px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: 'relative',
    backgroundColor: '#F4F6F8',
    borderRadius: '16px',
    border: 'none',
    padding: '10px',
    overflow: 'inherit',
    gap: '12px',
    top: '-60 !important',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    height: 'calc(100% - 56px)',
    borderBottomRightRadius: '16px',
  },
  drawerClosePaper: {
    height: 'calc(100% - 56px)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    top: 57,
    padding: '12px',
    overflowX: 'hidden',
    width: theme.spacing(7),
    position: 'fixed',
    backgroundColor: '#F4F6F8',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    border: 'none',
    zIndex: 1200,
  },
  sectionDiv: {
    height: '100%',
    backgroundColor: '#F4F6F8',
    color: '#002E47',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    // Always scrollable, never toggled on hover. A webkit scrollbar takes its width out of the
    // content box, so revealing one on hover used to narrow the rows by 4px and shunt every
    // right-aligned Draft/Edited badge sideways. The bar is hidden by fading its thumb instead,
    // which leaves the layout alone.
    overflowY: 'scroll',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
      scrollbarColor: '#CBD5E0 transparent',
    },
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#F4F6F8',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
      borderRadius: '4px',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      background: '#CBD5E0',
      '&:hover': {
        background: '#A0AEC0',
      },
    },
    '&::-webkit-scrollbar-track-piece:start': {
      backgroundColor: 'transparent',
      marginTop: '16px',
    },
    '&::-webkit-scrollbar-track-piece:end': {
      backgroundColor: 'transparent',
      marginBottom: '16px',
    },
  },
  // The collapsed rail has nothing to scroll, so it opts out of the reserved gutter entirely.
  sectionDivClose: {
    overflowY: 'hidden',
    overflowX: 'hidden',
    '&:hover': {
      overflowY: 'hidden',
      overflowX: 'hidden',
    },
  },
})

export default styles
